function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { addGlobalEventProcessor, getCurrentHub } from '@sentry/core';
import { WINDOW } from '../helpers.js';

/** HttpContext integration collects information about HTTP request headers */
class HttpContext {
  constructor() {
    HttpContext.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = 'HttpContext';
  }

  /**
   * @inheritDoc
   */
  __init() {
    this.name = HttpContext.id;
  }

  /**
   * @inheritDoc
   */
  setupOnce() {
    addGlobalEventProcessor(event => {
      if (getCurrentHub().getIntegration(HttpContext)) {
        // if none of the information we want exists, don't bother
        if (!WINDOW.navigator && !WINDOW.location && !WINDOW.document) {
          return event;
        }

        // grab as much info as exists and add it to the event
        const url = event.request && event.request.url || WINDOW.location && WINDOW.location.href;
        const _ref = WINDOW.document || {},
          referrer = _ref.referrer;
        const _ref2 = WINDOW.navigator || {},
          userAgent = _ref2.userAgent;
        const headers = _objectSpread(_objectSpread(_objectSpread({}, event.request && event.request.headers), referrer && {
          Referer: referrer
        }), userAgent && {
          'User-Agent': userAgent
        });
        const request = _objectSpread(_objectSpread(_objectSpread({}, event.request), url && {
          url
        }), {}, {
          headers
        });
        return _objectSpread(_objectSpread({}, event), {}, {
          request
        });
      }
      return event;
    });
  }
}
HttpContext.__initStatic();
export { HttpContext };